import { useState } from "react";
import {
  Button,
  DownloadSVG,
  LoadingSpinner,
  visuallyHiddenStyles,
} from "@newsela/angelou";
import downloadCsvFromUrl from "@/reports/utils/downloadCsvFromUrl";
import { csvButtonCss } from "./DownloadCSVButton.styles";

export interface DownloadCSVProps {
  downloadCsvUrl?: string | undefined;
  downloadCsvFilename?: string | undefined;
  ariaLabel?: string | undefined;
}

const DEFAULT_ARIA_LABEL = "Download as .csv";

const DownloadCSVButton = (props: DownloadCSVProps) => {
  const {
    downloadCsvUrl,
    downloadCsvFilename,
    ariaLabel = DEFAULT_ARIA_LABEL,
  } = props;

  const [loadingDownload, setLoadingDownload] = useState(false);

  const handleDownload = () => {
    if (!loadingDownload && downloadCsvUrl) {
      setLoadingDownload(true);
      downloadCsvFromUrl(
        downloadCsvUrl,
        downloadCsvFilename || "report.csv",
      ).then(() => setLoadingDownload(false));
    }
  };

  return (
    <Button
      __cssFor={{
        root: csvButtonCss,
      }}
      flavor={Button.flavors.tertiary}
      onClick={handleDownload}
      size={Button.sizes.md}
      icon={{
        SvgComponent: loadingDownload ? LoadingSpinner : DownloadSVG,
        alignment: Button.iconAlignments.left,
      }}
      ariaProps={{
        "aria-label": ariaLabel,
      }}
    >
      <span>Download as .csv</span>
      <div css={visuallyHiddenStyles} role="status">
        {loadingDownload ? "Downloading CSV file..." : ""}
      </div>
    </Button>
  );
};

export default DownloadCSVButton;
